import { useEffect } from 'react';
import { Table, useFilters, SchemaFilterType, SelectItemProps } from '@ui/src';
import { useAppSelector } from '@store';
import {
  overviewAccountsFiltersSchema,
  overviewAccountsColumns,
  overviewAccountsColumnsLabels,
} from '../../../hoc/customers/variables/overview-accounts';
import { OverviewStatementsTransactionTypes } from './types';

import cn from './overview-statements.module.css';

const OverviewStatementsTransaction = ({
  onSort,
  onFilter,
  data,
  filters,
  sort,
  accountId,
  requestInProgress,
  errorList,
}: OverviewStatementsTransactionTypes): React.JSX.Element => {
  const { currencies } = useAppSelector((state) => state.customersDictionaries);

  const { filtersComponent, setValues, handleSubmit, reset } = useFilters({
    filtersSchema: overviewAccountsFiltersSchema,
    filters,
    onFilterChange: onFilter,
  });

  useEffect(() => {
    setValues('currencyId', currencies as SelectItemProps[]);
  }, [currencies]);

  useEffect(() => {
    if (filters) {
      const nextFilters = { ...filters };

      if (nextFilters.type) {
        delete nextFilters.type;
      }

      reset(nextFilters);
    }
  }, [filters]);

  return (
    <div>
      {currencies && (
        <Table
          columns={overviewAccountsColumns}
          data={data || []}
          onSort={(name) => onSort(name)}
          filters={filters}
          sort={sort}
          columnsLabels={overviewAccountsColumnsLabels}
          error={errorList}
          onFilterChange={(values) => {
            if (!values.accountId) {
              onFilter({
                accountId: {
                  value: [accountId as string],
                  type: SchemaFilterType.STRING,
                },
              });
            } else {
              onFilter(values);
            }
          }}
          filtersComponent={filtersComponent}
          handleSubmit={handleSubmit}
          isLoading={requestInProgress}
          tableFormClassName={cn.overviewStatementsTableForm}
          tableHeadCellClassName={cn.overviewStatementsTableHeadCell}
          tableBodyClassName={!accountId ? cn.emptySeletedAccount : ''}
          clickable
        />
      )}
    </div>
  );
};

export default OverviewStatementsTransaction;
